export const API_BASE = 'https://api.pixelitos.ec/'
// export const API_BASE = 'http://api.interactiva.editorialsuramerica.com/'
// export const API_BASE = 'http://api.club.0drama.com.ec/'



// WEBPACK FOOTER //
// ./src/config.js